module.exports = __webpack_public_path__ + "img/message_comment@2x.c67aafaf.png";